import { OrganizerSharedPageContainerTabBarConfigInterface } from '~/organizer/shared/components/shared/page-container/interfaces/tab-bar-config.interface';

export const organizerActivityCreationStepperTabBarConfig: OrganizerSharedPageContainerTabBarConfigInterface[] =
  [
    {
      contentKey: 'activity_creation.page_container.stepper_tab_bar.1',
    },
    {
      contentKey: 'activity_creation.page_container.stepper_tab_bar.2',
    },
    {
      contentKey: 'activity_creation.page_container.stepper_tab_bar.3',
    },
    {
      contentKey: 'activity_creation.page_container.stepper_tab_bar.4',
    },
  ];
